<script>
  import sanitizeClassName from '../../utils/sanitizeClassName';

  let {
    title = '',
    dataTestId = 'page-heading',
    xlVerticalPadding = 'xl:py-18',
    className = $bindable(''),
    itemprop = undefined,
    centered = true,
  } = $props();

  className = sanitizeClassName(className);
</script>

<section
  class={`${xlVerticalPadding} flex items-center py-4 min-h-22 lg:py-12 bg-blue-very-light ${className}`}
  class:justify-center={centered}
  data-testid={dataTestId}
>
  <h1
    {itemprop}
    class="flex-1 w-full max-w-6xl px-4 lg:mx-auto text-blue-dark-navy text-1.5xl lg:text-4xl leading-tight lg:leading-10"
    class:text-center={centered}
    class:max-w-xl={centered}
    class:lg:max-w-3xl={centered}
  >
    {title}
  </h1>
</section>
